import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../Assets/WebsiteCss/aboutus.css'
import { Container, Row, Col, Card } from 'react-bootstrap'

import aboutbanner from '../Assets/food/Company.jpg'
import aboutimg from '../Assets/food/aboutUsimg.jpg'

import misionimg from '../Assets/Image/mission.png';
import visionimg from '../Assets/Image/vision.png';
import missionImg from '../Assets/food/22.png'

import { FaStar, FaBoxOpen, FaCheckCircle, FaTruck } from "react-icons/fa";
import { FaLeaf, FaCog, FaBox, FaTools, FaHandshake  } from 'react-icons/fa';
import { FaEye } from "react-icons/fa";
import { GoGoal } from "react-icons/go";
import { FcCollaboration } from "react-icons/fc";
import { MdSupervisorAccount } from "react-icons/md";

import { Helmet } from "react-helmet";


export default function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const missionVisionData = [
    {
      icon: visionimg,
      title: "Vision",
      description:
        "To become India’s most trusted and loved namkeen manufacturer, delivering traditional flavors with modern excellence.",
    },
    {
      icon: misionimg,
      title: "Mission",
      description:
        "   To craft high-quality, authentic, and delicious namkeen while ensuring the best manufacturing standards and customer satisfaction.",
    },

  ];

  const whyChooseUsData = [
    {
      icon: <FaStar className="icon text-yellow" />,
      title: "15+ Years of Experience",
      description: "Trusted by thousands for quality and taste."
    },
    {
      icon: <MdSupervisorAccount  className="icon text-blue" />,
      title: "Experianced Workers",
      description: "Our experienced supervisors ensure smooth operations."
    },
    {
      icon: <FaHandshake  className="icon text-green" />,
      title: "Trust Labors",
      description: "TrustLabors provides skilled and reliable workers across industries"
    },
    {
      icon: <FcCollaboration  className="icon text-orange" />,
      title: "Pan India labor supply",
      description: "Enjoy our delicious namkeen anywhere in India."
    }
  ];

  const expertiseData = [
    {
      title: "Raw Material Sourcing",
      icon: <FaLeaf size={30} />, // Using React Icon here
      description: "We procure the best quality ingredients for our namkeen, ensuring premium taste and authenticity in every batch.",
    },
    {
      title: "Manufacturing & Processing",
      icon: <FaCog size={30} />, // Using React Icon here
      description: "Our skilled workforce and efficient processes ensure that every namkeen product is made to perfection.",
    },
    {
      title: "Packaging & Distribution",
      icon: <FaBox size={30} />, // Using React Icon here
      description: "We ensure safe, secure, and timely packaging, maintaining freshness until our namkeen reaches you.",
    },
    {
      title: "Consultancy Services",
      icon: <FaTools size={30} />, // Using React Icon here
      description: "We assist in setting up namkeen production units and provide expert consultancy for machine installations.",
    },
  ];



  return (
    <>
      <div className="mainnav min-vh-100 ">

     
      <Helmet>
        {/* Page Title */}
        <title>About Us | Karigar India Namkeen Labour Contractor</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Learn about Karigar India Namkeen Labour Contractor – trusted manpower solutions for namkeen, sweets, snacks, and bakery units. Skilled Karigars, supervisors, machine operators, and packing staff ensure high-quality production across India."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Karigar India, Namkeen Karigar, Sweets Karigar, Snacks Karigar, Bakery Karigar, Labour Contractor, Skilled Manpower, Bhujia, Sev, Chivda, Mithai, Packing Staff, Factory Labor Supply"
        />

        {/* Author */}
        <meta name="author" content="Karigar India" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="About Us | Karigar India Namkeen Labour Contractor" />
        <meta property="og:description" content="Karigar India provides skilled manpower for namkeen, sweets, snacks, and bakery manufacturing units, including experienced Karigars, supervisors, and packing staff." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.karigarindia.in/about" />
        <meta property="og:image" content="https://www.karigarindia.in/logo.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | Karigar India Namkeen Labour Contractor" />
        <meta name="twitter:description" content="Providing skilled workforce solutions for namkeen, sweets, snacks, and bakery units across India. Hire Karigars, supervisors, and packing staff today." />
        <meta name="twitter:image" content="https://www.karigarindia.in/logo.png" />

        {/* Favicon */}
        <link rel="icon" href="/logo.png" />
      </Helmet>
        <div className="service-container">
          <img src={aboutbanner} alt="About Banner" className="servicenamkken img-fluid " />
          <div className="service-overlay"></div>

          {/* <div className="service-text" >
            Delivering Authentic Taste and Premium Quality in Every Crunch.
          </div> */}
        </div>

        <Container>
          <div className="mb-2 mt-3" >
            <h2 className="middletext mb-3" data-aos="zoom-in">About Us</h2>
            <Row className='m-0'>
              <Col lg={5} className="d-flex justify-content-center" >
                <img
                  src={aboutimg}
                  alt=""
                  style={{ height: "300px", width: '90%', objectFit: 'fill', borderRadius: "8px", marginBottom: '10px' }}
                />
              </Col>
              <Col lg={7} >
                <p style={{ textAlign: "justify", fontsize:15 }}>
                  <b> Karigar India Namkeen Labour Contractor</b> is a trusted and well-established Skilled Manpower & Labour Contractor service in India, offering complete workforce solutions for namkeen, sweets, snacks, and bakery manufacturing units. We specialize in providing highly experienced namkeen karigars skilled in bhujia, sev, chivda, dal, and mixed namkeen production. Along with namkeen experts, we also supply mithai karigars, snacks karigars, bakery karigars, and trained packing department staff to handle hygienic and efficient packaging operations.

                  Our manpower services extend to machine operators, supervisors, and quality control staff, ensuring smooth production flow, quality consistency, and factory discipline. From small-scale units to large manufacturing plants, Karigar India delivers complete factory labour supply solutions tailored to business requirements. With a strong focus on skill, hygiene, reliability, and timely deployment, we help manufacturers improve productivity and maintain industry standards. Backed by years of practical experience, Karigar India stands as a dependable manpower partner, supporting food manufacturing units across India with skilled workforce solutions that drive growth and operational excellence.
                </p>
              </Col>
            </Row>
          </div>

          <div className="mb-2 mt-3">
            <section class="mission-vision">
              <div class="mv-container">

                {/* <!-- Left Content --> */}
                <div class="mv-left middletext">
                  <h3><b data-aos="zoom-in">Mission and Vision</b></h3>
                  <p class="mv-desc">
                    To create <b style={{ color: 'red' }}>'Har Ghar, Khushi'</b>  by providing a diverse range of delicious and affordable snacks that celebrate our rich culinary heritage.
                  </p>
                </div>

                {/* <!-- Center Image --> */}
                <div class="mv-center">
                  <div class="circle-wrapper">
                    <img src={missionImg} alt="Food Plate" />
                  </div>
                </div>

                {/* <!-- Right Content --> */}
                <div class="mv-right">
                  <div class="mv-box mission">
                    <h3><FaEye /> Mission</h3>
                    <p>
                      Our mission is to consistently deliver premium, authentic Indian snacks by upholding rigorous manufacturing standards and utilizing traditional recipes.
                    </p>
                  </div>

                  <div class="mv-box vision">
                    <h3><GoGoal /> Vision</h3>
                    <p>
                      To grow with pace, expand our reach, and become a trusted
                      food brand known for taste and quality worldwide.
                    </p>
                  </div>
                </div>

              </div>
            </section>

          </div>

          <div className="why-choose-us mt-3 mb-5" data-aos="zoom-in" >
            <h2 className="middletext2 text-center" data-aos="zoom-in">Who We Are</h2>

            <Row className="justify-content-center mb-4 m-0">
              <Col lg={10} className="d-flex justify-content-center">
                <div style={{ maxWidth: "800px", textAlign: "center", textAlign: 'justify' }}>
                  <p>
                    We are a leading namkeen and savory snacks manufacturer committed to bringing the authentic essence of Indian flavors to every household. Founded on the principles of quality, purity, and tradition, our journey began with a simple goal, to create snacks that remind people of home. Today, we stand as a symbol of trust, blending time honored recipes passed down through generations with cutting edge, automated manufacturing technology to ensure world class standards. Every product we craft is a result of meticulous ingredient selection from the finest spices to the highest quality oils ensuring that we never compromise on health or taste. We pride ourselves on being more than just a food brand; we are a part of your daily celebrations, tea time conversations, and family gatherings. Driven by innovation and a deep respect for our culinary roots, we continue to expand our flavors to satisfy the modern palate while staying true to the traditional crunch that defines authentic namkeen.
                  </p>
                </div>
              </Col>
            </Row>
          </div>


          <div className="mt-4 ">
            <h2 className="middletext mb-5" data-aos="zoom-in">Why Choose Us</h2>

            <Row className="justify-content-center m-0">
              {whyChooseUsData.map((item, index) => (
                <Col md={3} sm={6} xs={6} key={index} className="mb-5 mt-4">
                  <div className="choose-card">

                    {/* ICON CIRCLE */}
                    <div className="icon-circle">
                      {item.icon}
                    </div>

                    {/* CARD CONTENT */}
                    <div className="card-content">
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </div>

                  </div>
                </Col>
              ))}
            </Row>
          </div>

        </Container>
      </div>
    </>
  )
}
